
<template>
    <v-dialog v-model="dialog" width="800px">
        <v-card flat>
            <v-card-title class="justify-center">{{ mltp.mltp_title }}</v-card-title>
            <v-divider/>
            <v-card-text>
                <v-row class="pa-2">
                    <v-col cols="3">Company</v-col>
                    <v-col cols="9">{{ mltp.mltp_company }}</v-col>
                    <v-col cols="3">Template header</v-col>
                    <v-col cols="9">{{ mltp.mlhf_nr }} {{ mltp.mlhf_oms }}</v-col>
                    <v-col cols="3">Template for</v-col>
                    <v-col cols="9">{{ mltp.mltp_doelgroep }}</v-col>
                    <v-col cols="3">Template description</v-col>
                    <v-col cols="9"><v-text-field v-model="mltp.mltp_desc" label="Template description" dense></v-text-field></v-col>
                </v-row>
                <v-divider/>
                <div class="pa-2">This will create a new tempate 'set' using the {{ mltp.mlhf_nr }} ({{ mltp.mlhf_oms }}) header & footer.</div>
                <div class="pa-2" v-if="mltp.mltp_source > 0">
                    It will copy Subject & mail texts for both 'Test' & 'Production' templates in all languages to the new tempate.
                </div>
                <div class="pa-2" v-else>
                    It will create empty Subject & mail texts for both 'Test' & 'Production' in all languages.
                </div>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <v-btn color="success" :disabled="mltp.mltp_desc === ''" @click="createNewMltp">Create</v-btn>
                <v-btn color="error" @click="closeNewMltp">Cancel</v-btn>
            </v-card-actions>
        </v-card>  
    </v-dialog>
</template>

<script>
    export default {
        components: {
        },
        data() {
            return {
                dialog: false,
                mltp : {
                    mltp_title: "",
                    mltp_nr: 0,
                    mltp_doelgroep: "",
                    mltp_company: "",
                    mlhf_nr: 0,
                    mlhf_oms: "",
                    mltp_source: 0,
                    mltp_desc: ""
                }
            }  
        },
        methods: {
            openNewMltp(mltp_nr) {
                this.$axios.post("ares/json/ares/syst/mltp/getMltpToAdd.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getMltpToAdd"
                    },
                    getMltpToAdd: {
                        mltp_nr: mltp_nr
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.mltp =  res.data.getMltpToAdd
                        this.dialog = true
                    }
                });
            },
            createNewMltp() {
                this.$axios.post("ares/json/ares/syst/mltp/addMltp.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "addMltp"
                    },
                    addMltp: {
                        mltp: this.mltp
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.addMltp.text,
                            color: res.data.addMltp.color
                        });
                        if (res.data.addMltp.color === "success") {
                            this.$emit("reload")
                            this.closeNewMltp()
                        }
                    }
                });
            },
            closeNewMltp() {
                this.dialog = false
            }
        }
    };
</script> 

<style scoped>
</style>